import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { getStorefrontStorageKey } from '@/common/storefront/storefront.config'

interface AppStore {
  orderUrl: string
  trainStatus: string
  setOrderUrl: (value: string) => void
  /**
   * Kiểm tra trạng thái "continue_order" khi khách hàng nhấn vào nút "Tiếp tục đặt món" trên trang giới thiệu ứng dụng
   * Nếu trạng thái là "continue_order" thì sẽ không hiển thị lại trang giới thiệu ứng dụng nữa mà sẽ chuyển hướng trực tiếp đến trang đặt món
   * @param value 
   * @returns 
   */
  setTrainStatus: (value: string) => void
  clearOrderUrl: () => void
}

export const useAppSession = create<AppStore>()(
  persist(
    (set) => ({
      orderUrl: '',
      trainStatus: "",

      setOrderUrl: (value) =>
        set({
          orderUrl: value,
        }),

      clearOrderUrl: () =>
        set({
          orderUrl: '',
        }),

      setTrainStatus: (value) => {
        set({
          trainStatus: value
        })
      },
    }),
    {
      name: getStorefrontStorageKey(`app-order:${import.meta.env.VITE_APP_ID}`),
      storage: createJSONStorage(() => sessionStorage),
    }
  )
)
